import { moduleLogger } from "../Logger";
import type { ApiClient } from "../api/ApiClient";
import type { DetailviewBenefit } from "./DetailviewBenefit";

const log = moduleLogger.scope("benefit-cache");

export class BenefitCache {
	private cache: Map<string, Promise<DetailviewBenefit | undefined>> = new Map();

	private textDecoder = new TextDecoder();

	constructor(private readonly apiClient: ApiClient) {}

	/**
 *
 *
 *
 */
	async getBenefit(variationId: string, productId?: string, autoActivateBenefitId?: string): Promise<DetailviewBenefit | undefined> {
		const cacheKey = `${variationId}-${productId ? productId : "undefined"}`;

		if (!this.cache.has(cacheKey)) {
			const benefitPrefetch = this.getBenefitFromDom(variationId);
			let benefit = Promise.resolve(benefitPrefetch?.benefit);

			try {
				if (!benefitPrefetch) {
					benefit = this.apiClient.getBestMatchBenefit(variationId, productId, autoActivateBenefitId);
					/*                                                                                                                            */
				} else if (benefitPrefetch.productId) {
					this.cache.set(`${variationId}-${benefitPrefetch.productId}`, benefit);
				}

				if (productId) {
					this.cache.set(`${variationId}-${productId}`, benefit);
				}
				this.cache.set(`${variationId}-undefined`, benefit);

				document.getElementById("ft9-benefit-detailview-frontend")?.remove();
			} catch (e: unknown) {
				if (e instanceof Error) {
					log.error(`cannot load benefit from backend: ${e.message}`);
				} else if (typeof e === "string") {
					log.error(`cannot load benefit from backend: ${e}`);
				}
				throw e;
			}
		}

		return this.cache.get(cacheKey);
	}

	/*         */
	getBenefitFromDom(variationId: string): BenefitPrefetch | undefined {
		const benefitElement = document.getElementById("ft9-benefit-detailview-frontend");

		if (benefitElement) {
			const variationIdDom = benefitElement.dataset.variationId;
			const productIdDom = benefitElement.dataset.productId;
			const benefitDom = benefitElement.dataset.benefitAsJsonBase64;

			if (variationIdDom === variationId && benefitDom) {
				return {
					variationId: variationIdDom,
					productId: productIdDom,
					benefit: JSON.parse(this.textDecoder.decode(this.base64ToBytes(benefitDom)), (key: string, value: string) => {
						if (key === "activeUntil") return new Date(value);
						return value;
					}),
				};
			}
			if (variationIdDom === variationId) {
				return {
					variationId: variationIdDom,
					productId: productIdDom,
					benefit: undefined,
				};
			}
		}
	}

	private base64ToBytes(base64: string) {
		const binString = atob(base64);

		return Uint8Array.from(Array.from(binString).map((letter) => letter.charCodeAt(0)));
	}

	reset() {
		this.cache.clear();
	}
}

interface BenefitPrefetch {
	variationId: string;
	benefit?: DetailviewBenefit;
	productId?: string;
}
